import {ArrowDownward, Close} from '@mui/icons-material';
import {Menu, MenuItem, styled} from '@mui/material';
import React, {useState} from 'react';
import {useContactTypes} from '../../../../hooks';

const Container = styled('div')(({theme}) => ({
  borderBottom: `2px solid ${theme.palette.grey['100']}`,
  borderTop: `2px solid ${theme.palette.grey['100']}`,
  display: 'flex',
  flex: 1,
  width: '100%',

  '& > span': {
    alignItems: 'center',
    display: 'flex',
    flex: 0,
    padding: `0 ${theme.spacing(2)}`,
  }
}));

const Types = styled('ul')(({theme}) => ({
  display: 'flex',
  flex: 1,
  listStyle: 'none',
  margin: 0,
  padding: `0 ${theme.spacing(2)} 0 0`,
}));

const Type = styled('li')(({theme}) => ({
  borderLeft: `2px solid ${theme.palette.grey['100']}`,
  color: 'var(--type-colour)',
  cursor: 'pointer',
  fontWeight: '700',
  padding: `${theme.spacing(1)} ${theme.spacing(2)}`,

  '&:last-of-type': {
    borderRight: `2px solid ${theme.palette.grey['100']}`,
  },

  '&.selected': {
    background: 'var(--type-colour)',
    color: theme.palette.common.white,
  }
}));

const Material = styled('div')(({theme}) => ({
  alignItems: 'center',
  borderLeft: `2px solid ${theme.palette.grey['100']}`,
  cursor: 'pointer',
  display: 'flex',
  fontWeight: 600,
  padding: `0 ${theme.spacing(2)}`,

  '& .icon': {
    fontSize: 16,
    marginLeft: theme.spacing(1)
  }
}));

const Filter = ({type, onChangeType, materials, material, onChangeMaterial}) => {
  const types = useContactTypes();
  const [materialsOpen, setMaterialsOpen] = useState(false);
  const [menuAnchor, setMenuAnchor] = useState(null);

  return (
    <Container>
      <span>Displaying:</span>
      <Types>
        {types.map(({title, key, colour}, index) => (
          <Type
            key={index}
            className={type === key ? 'selected' : ''}
            style={{'--type-colour': colour}}
            onClick={() => type === key ? null : onChangeType(key)}
          >
            {title}
          </Type>
        ))}
      </Types>
      {materials.length ? (
        <>
          <Material
            onClick={(e) => setMenuAnchor(e.currentTarget) || setMaterialsOpen(true)}
          >
            {material ? material.name : 'Filter by Material'}
            {material ? <Close className="icon" onClick={() => onChangeMaterial(null)}/> :
              <ArrowDownward className="icon"/>}
          </Material>
          <Menu
            anchorEl={menuAnchor}
            open={materialsOpen}
            onClose={() => setMaterialsOpen(false)}
          >
            {materials.map((material, index) => (
              <MenuItem key={index} onClick={() => onChangeMaterial(material)}>{material.name}</MenuItem>
            ))}
          </Menu>
        </>
      ) : null}
    </Container>
  );
}

export default Filter;
